import { ThemeNames } from 'types/themes';

export const JOIN_APP_EXPREALTY = 'https://joinapp.exprealty.com/';

/**
 * Resolves the eXp Realty US join-exp FAB / Join Now URL.
 * Server-side only: set JOIN_EXP_FAB_DESTINATION on the pod to override without a rebuild.
 * Does not apply to eXp CA.
 */
export function getJoinExpFabDestination(): string {
  const override = process.env.JOIN_EXP_FAB_DESTINATION?.trim();
  if (override) {
    return override;
  }
  return JOIN_APP_EXPREALTY;
}

// eXp Realty US agent hub — opened when an agent is selected on the role-selection screen.
export const HUB_EXPREALTY = 'https://hub.exprealty.com';

export const JOIN_EXPREALTY_CA_CONTACT = '/join-exp-ca-contact';

export const JoinPageContactPages = {
  [ThemeNames.EXP_REALTY_US]: '/join-exp-us-contact',
  [ThemeNames.EXP_REALTY_CA]: '/join-exp-ca-contact',
};

export const JoinPageContactPaths = {
  [ThemeNames.EXP_REALTY_US]: '/contact',
  [ThemeNames.EXP_REALTY_CA]: '/contact-ca',
};

export const FEEDBACK_BANNER_SURVEY_URL = 'https://www.riddle.com/view/xrV2QHzT';

export const ACCESSIBILITY_PATH = '/accessibility';

export const EXP_INTERNATIONAL_LINKS_URLS = Object.freeze({
  CANADA: 'https://exprealty.ca/',
  UNITED_STATES: 'https://exprealty.com/',
  BRAZIL: 'https://www.expglobalbrasil.com.br/',
  CHILE: 'https://www.expchile.cl/',
  COLOMBIA: 'https://www.expcolombia.co/',
  DOMINICAN_REPUBLIC: 'https://www.expdr.com/',
  ECUADOR: 'https://expecuador.com/',
  MEXICO: 'https://www.expmexico.mx/',
  PERU: 'https://expperu.pe/',
  PUERTO_RICO: 'https://www.exppuertorico.pr',
  UNITED_ARAB_EMIRATES: 'https://www.expdubai.com/',
  FRANCE: 'https://www.expfrance.fr/',
  GERMANY: 'https://www.expgermany.de/',
  INDIA: 'https://www.expglobalindia.co.in/',
  ISRAEL: 'https://www.expisrael.co.il/',
  ITALY: 'https://www.expitaly.it/',
  LUXEMBOURG: 'https://expluxembourg.com',
  NETHERLANDS: 'https://expnederland.com',
  POLAND: 'https://www.exppoland.pl/',
  PORTUGAL: 'https://expportugal.com/',
  ROMANIA: 'https://expromania.ro',
  SOUTH_AFRICA: 'https://www.expsouthafrica.co.za/',
  SPAIN: 'https://www.expglobalspain.com/',
  TURKIYE: 'http://expturkiye.com/',
  UNITED_KINGDOM: 'https://exp.uk.com',
  AUSTRALIA: 'https://www.expaustralia.com.au',
  HONG_KONG: 'https://www.exphk.hk/',
  JAPAN: 'https://www.expjapan.co.jp/',
  SOUTH_KOREA: 'https://expkr.com',
  NEW_ZEALAND: 'https://expnz.nz/',
} as const);
